import {http} from "@/config/HttpClient";
import {Alert} from "@/addons/Alert";
import {globalStore} from "@/store/globalStore";
import { useConsultorioStore } from "@/store/consultorioStore";
import {AxiosResponse} from "axios";
import {DateTime} from 'luxon';


export class consultorioService {
    private static instance: consultorioService;
		baseURL= `${process.env.VUE_APP_URL}`;
    public static getInstance() {
        return this.instance || (this.instance = new this());
    }

    globalStore = globalStore();
    consultorioStore = useConsultorioStore();
   

    public async getCitas(data: any) {
			this.consultorioStore.loading = true;
      await http.get("citas-medicas", {params: data}).subscribe({
          next: (response:AxiosResponse) => {
            this.consultorioStore.citas = response.data.data;
						this.makePagination(response.data);
					this.consultorioStore.loading = false;
          },
      })
    }

    public async getTratamientos() {
			this.consultorioStore.loading = true;
    await http.get("tratamientos").subscribe({
			next: (response:AxiosResponse) => {
					this.consultorioStore.tratamientos = response.data;
          this.consultorioStore.loading = false;
			},
    })
		}

	public async getPacientesSearch(data: any) {
		this.consultorioStore.loading = true;
      await http.get("get-pacientes-search", {params: data}).subscribe({
          next: (response:AxiosResponse) => {
            this.consultorioStore.pacientes = response.data.data;
						this.makePagination(response.data);
						this.consultorioStore.loading = false;
          },
      })
    }
	public async getPacientes(txtSearch: string) {
			const data = {txtSearch: txtSearch == ''? null: txtSearch}
      await http.get("pacientes", {params: data}).subscribe({
          next: (response:AxiosResponse) => {
            this.consultorioStore.pacientes = response.data;
          },
      })
    }
    public async getReservas(data: any) {
        await http.get("reservas", {params: data}).subscribe({
            next: (response:AxiosResponse) => {
                this.consultorioStore.reservas = response.data;
            },
        })
    }

    public async getCaras() {
        await http.get("getCaras").subscribe({
            next: (response:AxiosResponse) => {
                this.consultorioStore.caras = response.data;
            },
        })
    }

	public async registrarCita(data: any): Promise<any> {
      return new Promise((resolve, reject) => {
          this.consultorioStore.loading = true;
          http.post("citas-medicas", data).subscribe({
              next: (response: AxiosResponse) => {
                  this.consultorioStore.loading = false;
                  if (response.data.res) {
                      Alert.successTotastr("Cita registrada exitosamente!","Exito");
                      // console.log(response.data);
                      // this.imprimirOrden(response.data.id)
                      resolve(response.data);
                  } else {
                      Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                      resolve(false);
                  }
              },
              error: (error) => {
                  this.consultorioStore.loading = false;
                  reject(error);
              }
          })
      });
    }
    public async registrarReserva(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.consultorioStore.loading = true;
            http.post("reservas", data).subscribe({
                next: (response: AxiosResponse) => {
                    this.consultorioStore.loading = false;
                    if (response.data.res) {
                        Alert.successTotastr("Reserva registrada exitosamente!","Exito");
                        // console.log(response.data);
                        // this.imprimirOrden(response.data.id)
                        resolve(response.data);
                    } else {
                        Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                        resolve(false);
                    }
                },
                error: (error) => {
                    this.consultorioStore.loading = false;
                    reject(error);
                }
            })
        });
      }

	public async registrarTratamiento(data: any): Promise<any> {
      return new Promise((resolve, reject) => {
          this.consultorioStore.loading = true;
          http.post("tratamientos", data).subscribe({
              next: (response: AxiosResponse) => {
                  this.consultorioStore.loading = false;
                  if (response.data.res) {
                      Alert.successTotastr("Tratamiento registrado exitosamente!","Exito");
                      // console.log(response.data);
                      // this.imprimirOrden(response.data.id)
                      resolve(response.data);
                  } else {
                      Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                      resolve(false);
                  }
              },
              error: (error) => {
                  this.consultorioStore.loading = false;
                  reject(error);
              }
          })
      });
    }

	public async registrarPaciente(data: any): Promise<any> {
      return new Promise((resolve, reject) => {
          this.consultorioStore.loading = true;
          http.post("pacientes", data).subscribe({
              next: (response: AxiosResponse) => {
                  this.consultorioStore.loading = false;
                  if (response.data.res) {
                      Alert.successTotastr("Paciente registrado exitosamente!","Exito");
                      // console.log(response.data);
                      // this.imprimirOrden(response.data.id)
                      resolve(response.data);
                  } else {
                      Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                      resolve(false);
                  }
              },
              error: (error) => {
                  this.consultorioStore.loading = false;
                  reject(error);
              }
          })
      });
    }

	public async showPaciente(id: number): Promise<any> {
      return new Promise((resolve, reject) => {
          this.consultorioStore.loading = true;
          http.get(`pacientes/${id}`).subscribe({
              next: (response: AxiosResponse) => {
                this.consultorioStore.loading = false;
                this.consultorioStore.paciente = response.data
              },
              error: (error) => {
                  this.consultorioStore.loading = false;
                  reject(error);
              }
          })
      });
    }
    public async registrarDetalleOdontograma(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.consultorioStore.loading = true;
            http.post("detalle-odontograma", data).subscribe({
                next: (response: AxiosResponse) => {
                    this.consultorioStore.loading = false;
                    if (response.data.res) {
                        Alert.successTotastr("Registro correcto!","Exito");
                        // console.log(response.data);
                        // this.imprimirOrden(response.data.id)
                        resolve(response.data);
                    } else {
                        Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                        resolve(false);
                    }
                },
                error: (error) => {
                    this.consultorioStore.loading = false;
                    reject(error);
                }
            })
        });
      }

      public async adjuntarDocumento(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.consultorioStore.loading = true;
            http.post("documentos", data, {
							headers: {
                'Content-Type': 'multipart/form-data'
							}
						}).subscribe({
                next: (response: AxiosResponse) => {
                    this.consultorioStore.loading = false;
                    if (response.data.res) {
                        Alert.successTotastr("Registro correcto!","Exito");
                        // console.log(response.data);
                        // this.imprimirOrden(response.data.id)
                        resolve(response.data);
                    } else {
                        Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                        resolve(false);
                    }
                },
                error: (error) => {
                    this.consultorioStore.loading = false;
                    reject(error);
                }
            })
        });
      }
      public async storePago(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.consultorioStore.loading = true;
            http.post("pagos", data).subscribe({
                next: (response: AxiosResponse) => {
                    this.consultorioStore.loading = false;
                    if (response.data.res) {
                        Alert.successTotastr(response.data.message,"Exito");
                        // console.log(response.data);
                        // this.imprimirOrden(response.data.id)
                        resolve(response.data);
                    } else {
                        Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                        resolve(false);
                    }
                },
                error: (error) => {
                    this.consultorioStore.loading = false;
                    reject(error);
                }
            })
        });
      }
    public async getDocumentos(id: number): Promise<any> {
    return new Promise((resolve, reject) => {
        this.consultorioStore.loading = true;
        http.get(`getDocumentos/${id}`).subscribe({
            next: (response: AxiosResponse) => {
                this.consultorioStore.loading = false;
                this.consultorioStore.documentos = response.data
            },
            error: (error) => {
                this.consultorioStore.loading = false;
                reject(error);
            }
        })
    });
    }

    public async getDetalleOdontograma(id: any) {
        await http.get(`getDetalleOdontograma/${id}`).subscribe({
            next: (response:AxiosResponse) => {
                this.consultorioStore.detalle_odontograma = response.data;
            },
        })
    }

    public async getHistorial(id: any) {
        await http.get(`getHistorial/${id}`).subscribe({
            next: (response:AxiosResponse) => {
                this.consultorioStore.citas = response.data;
            },
        })
    }

    public async otrosTratamientos() {
        await http.get(`otros-tratamientos`).subscribe({
            next: (response:AxiosResponse) => {
                this.consultorioStore.otros_tratamientos = response.data;
            },
        })
    }

    public async getProductos(search:any) {
        const data = { txtSearch: search}
        await http.get(`productos`,{params: data}).subscribe({
            next: (response:AxiosResponse) => {
                this.consultorioStore.productos = response.data;
            },
        })
    }

    public async registrarProducto(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.consultorioStore.loading = true;
            http.post("productos", data).subscribe({
                next: (response: AxiosResponse) => {
                    this.consultorioStore.loading = false;
                    if (response.data.res) {
                        Alert.successTotastr(response.data.message,"Exito");
                        resolve(response.data);
                    } else {
                        Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                        resolve(false);
                    }
                },
                error: (error) => {
                    this.consultorioStore.loading = false;
                    reject(error);
                }
            })
        });
      }
    public async updateProducto(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.consultorioStore.loading = true;
            http.put(`productos/${data.id}`, data).subscribe({
                next: (response: AxiosResponse) => {
                    this.consultorioStore.loading = false;
                    if (response.data.res) {
                        Alert.successTotastr(response.data.message,"Exito");
                        resolve(response.data);
                    } else {
                        Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                        resolve(false);
                    }
                },
                error: (error) => {
                    this.consultorioStore.loading = false;
                    reject(error);
                }
            })
        });
    }
    public async getInsumos(search:any) {
        const data = { txtSearch: search}
        await http.get(`insumos`,{params: data}).subscribe({
            next: (response:AxiosResponse) => {
                this.consultorioStore.insumos = response.data;
            },
        })
    }

    public async registrarInsumo(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.consultorioStore.loading = true;
            http.post("insumos", data).subscribe({
                next: (response: AxiosResponse) => {
                    this.consultorioStore.loading = false;
                    if (response.data.res) {
                        Alert.successTotastr(response.data.message,"Exito");
                        resolve(response.data);
                    } else {
                        Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                        resolve(false);
                    }
                },
                error: (error) => {
                    this.consultorioStore.loading = false;
                    reject(error);
                }
            })
        });
      }
    public async updateInsumo(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.consultorioStore.loading = true;
            http.put(`insumos/${data.id}`, data).subscribe({
                next: (response: AxiosResponse) => {
                    this.consultorioStore.loading = false;
                    if (response.data.res) {
                        Alert.successTotastr(response.data.message,"Exito");
                        resolve(response.data);
                    } else {
                        Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                        resolve(false);
                    }
                },
                error: (error) => {
                    this.consultorioStore.loading = false;
                    reject(error);
                }
            })
        });
    }

    public async registrarRespuestas(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.consultorioStore.loading = true;
            http.post("store-respuestas", data).subscribe({
                next: (response: AxiosResponse) => {
                    this.consultorioStore.loading = false;
                    if (response.data.res) {
                        Alert.successTotastr(response.data.message,"Exito");
                        resolve(response.data);
                    } else {
                        Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                        resolve(false);
                    }
                },
                error: (error) => {
                    this.consultorioStore.loading = false;
                    reject(error);
                }
            })
        });
      }

		public async registrarFicha(data: any): Promise<any> {
			return new Promise((resolve, reject) => {
					this.consultorioStore.loading = true;
					http.post("fichas", data).subscribe({
							next: (response: AxiosResponse) => {
									this.consultorioStore.loading = false;
									if (response.data.res) {
											Alert.successTotastr(response.data.message,"Exito");
											resolve(response.data);
									} else {
											Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
											resolve(false);
									}
							},
							error: (error) => {
									this.consultorioStore.loading = false;
									reject(error);
							}
					})
			});
		}

		public async updateFicha(data: any): Promise<any> {
			return new Promise((resolve, reject) => {
					this.consultorioStore.loading = true;
					http.put(`fichas/${data.ficha_id}`, data).subscribe({
							next: (response: AxiosResponse) => {
									this.consultorioStore.loading = false;
									if (response.data.res) {
											Alert.successTotastr(response.data.message,"Exito");
											resolve(response.data);
									} else {
											Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
											resolve(false);
									}
							},
							error: (error) => {
									this.consultorioStore.loading = false;
									reject(error);
							}
					})
			});
	}

	public async updateCita(data: any): Promise<any> {
		return new Promise((resolve, reject) => {
				this.consultorioStore.loading = true;
				http.put(`citas-medicas/${data.id}`, data).subscribe({
						next: (response: AxiosResponse) => {
								this.consultorioStore.loading = false;
								if (response.data.res) {
										Alert.successTotastr(response.data.message,"Exito");
										resolve(response.data);
								} else {
										Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
										resolve(false);
								}
						},
						error: (error) => {
								this.consultorioStore.loading = false;
								reject(error);
						}
				})
		});
	}

	public async updateTratamiento(data: any): Promise<any> {
		return new Promise((resolve, reject) => {
				this.consultorioStore.loading = true;
				http.put(`tratamientos/${data.id}`, data).subscribe({
						next: (response: AxiosResponse) => {
								this.consultorioStore.loading = false;
								if (response.data.res) {
										Alert.successTotastr(response.data.message,"Exito");
										resolve(response.data);
								} else {
										Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
										resolve(false);
								}
						},
						error: (error) => {
								this.consultorioStore.loading = false;
								reject(error);
						}
				})
		});
	}

	public async updatePaciente(data: any): Promise<any> {
		return new Promise((resolve, reject) => {
				this.consultorioStore.loading = true;
				http.put(`pacientes/${data.id}`, data).subscribe({
						next: (response: AxiosResponse) => {
								this.consultorioStore.loading = false;
								if (response.data.res) {
										Alert.successTotastr(response.data.message,"Exito");
										resolve(response.data);
								} else {
										Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
										resolve(false);
								}
						},
						error: (error) => {
								this.consultorioStore.loading = false;
								reject(error);
						}
				})
		});
	}

	public async storeReceta(data: any): Promise<any> {
		return new Promise((resolve, reject) => {
				this.consultorioStore.loading = true;
				http.post("recetas", data).subscribe({
						next: (response: AxiosResponse) => {
								this.consultorioStore.loading = false;
								if (response.data.res) {
										Alert.successTotastr(response.data.message,"Exito");
										resolve(response.data);
								} else {
										Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
										resolve(false);
								}
						},
						error: (error) => {
								this.consultorioStore.loading = false;
								reject(error);
						}
				})
		});
	}

	public async storeCotizacion(data: any): Promise<any> {
		return new Promise((resolve, reject) => {
				this.consultorioStore.loading = true;
				http.post("cotizaciones", data).subscribe({
						next: (response: AxiosResponse) => {
								this.consultorioStore.loading = false;
								if (response.data.res) {
										Alert.successTotastr(response.data.message,"Exito");
										resolve(response.data);
								} else {
										Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
										resolve(false);
								}
						},
						error: (error) => {
								this.consultorioStore.loading = false;
								reject(error);
						}
				})
		});
	}

	public async updateCotizacion(data: any): Promise<any> {
		return new Promise((resolve, reject) => {
				this.consultorioStore.loading = true;
				http.put(`cotizaciones/${data.id}`, data).subscribe({
						next: (response: AxiosResponse) => {
								this.consultorioStore.loading = false;
								if (response.data.res) {
										Alert.successTotastr(response.data.message,"Exito");
										resolve(response.data);
								} else {
										Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
										resolve(false);
								}
						},
						error: (error) => {
								this.consultorioStore.loading = false;
								reject(error);
						}
				})
		});
	}

	public async getCotizaciones(data:any) {
		await http.get(`cotizaciones`,{params: data}).subscribe({
				next: (response:AxiosResponse) => {
						this.consultorioStore.cotizaciones = response.data.data;
						this.makePagination(response.data);
				},
		})
	}
	public async registrarReconsulta(data: any): Promise<any> {
		return new Promise((resolve, reject) => {
				this.consultorioStore.loading = true;
				http.post("reconsultas", data).subscribe({
						next: (response: AxiosResponse) => {
								this.consultorioStore.loading = false;
								if (response.data.res) {
										Alert.successTotastr(response.data.message,"Exito");
										resolve(response.data);
								} else {
										Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
										resolve(false);
								}
						},
						error: (error) => {
								this.consultorioStore.loading = false;
								reject(error);
						}
				})
		});
	}
	public async eliminarReconsulta(id: number): Promise<any> {
		return new Promise((resolve, reject) => {
				this.consultorioStore.loading = true;
				http.delete(`reconsultas/${id}`).subscribe({
						next: (response: AxiosResponse) => {
								this.consultorioStore.loading = false;
								if (response.data.res) {
										Alert.successTotastr(response.data.message,"Exito");
										resolve(response.data);
								} else {
										Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
										resolve(false);
								}
						},
						error: (error) => {
								this.consultorioStore.loading = false;
								reject(error);
						}
				})
		});
	}
    async imprimirSolicitud(id:number) {
			await http.get(`imprimir-receta/${id}`).subscribe(response =>{
						window.open(
							`${process.env.VUE_APP_URL}imprimir-receta/${id}`, "_blank");
							//import.meta.env.VITE_APP_URL +`imprimir-solicitud/${id}`, "_blank");
	
			})
		}
		public async eliminarPaciente(id: number): Promise<any> {
			return new Promise((resolve, reject) => {
					this.consultorioStore.loading = true;
					http.delete(`pacientes/${id}`).subscribe({
							next: (response: AxiosResponse) => {
									this.consultorioStore.loading = false;
									if (response.data.res) {
											Alert.successTotastr(response.data.message,"Exito");
											resolve(response.data);
									} else {
											Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
											resolve(false);
									}
							},
							error: (error) => {
									this.consultorioStore.loading = false;
									reject(error);
							}
					})
			});
		}
		public async eliminarDetalleOdontograma(id: number): Promise<any> {
			return new Promise((resolve, reject) => {
					this.consultorioStore.loading = true;
					http.delete(`detalle-odontograma/${id}`).subscribe({
							next: (response: AxiosResponse) => {
									this.consultorioStore.loading = false;
									if (response.data.res) {
											Alert.successTotastr(response.data.message,"Exito");
											resolve(response.data);
									} else {
											Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
											resolve(false);
									}
							},
							error: (error) => {
									this.consultorioStore.loading = false;
									reject(error);
							}
					})
			});
		}
		public async getEspecialidades() {
			await http.get(`especialidades`).subscribe({
					next: (response:AxiosResponse) => {
							this.consultorioStore.especialidades = response.data;
					},
			})
		}
		public async registrarEspecialidad(data: any): Promise<any> {
			return new Promise((resolve, reject) => {
					this.consultorioStore.loading = true;
					http.post("especialidades", data).subscribe({
							next: (response: AxiosResponse) => {
									this.consultorioStore.loading = false;
									if (response.data.res) {
											Alert.successTotastr(response.data.message,"Exito");
											resolve(response.data);
									} else {
											Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
											resolve(false);
									}
							},
							error: (error) => {
									this.consultorioStore.loading = false;
									reject(error);
							}
					})
			});
		}
		public async updateEspecialidad(data: any): Promise<any> {
			return new Promise((resolve, reject) => {
					this.consultorioStore.loading = true;
					http.put(`especialidades/${data.id}`, data).subscribe({
							next: (response: AxiosResponse) => {
									this.consultorioStore.loading = false;
									if (response.data.res) {
											Alert.successTotastr(response.data.message,"Exito");
											resolve(response.data);
									} else {
											Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
											resolve(false);
									}
							},
							error: (error) => {
									this.consultorioStore.loading = false;
									reject(error);
							}
					})
			});
		}
		public async actualizarUsuario(data: any): Promise<any> {
			return new Promise((resolve, reject) => {
					this.consultorioStore.loading = true;
					http.post("actualizar-usuario", data).subscribe({
							next: (response: AxiosResponse) => {
									this.consultorioStore.loading = false;
									if (response.data.res) {
											Alert.successTotastr(response.data.message,"Exito");
											this.globalStore.user = response.data.usuario;
											resolve(response.data);
									} else {
											Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
											resolve(false);
									}
							},
							error: (error) => {
									this.consultorioStore.loading = false;
									reject(error);
							}
					})
			});
		}
		public async getResinas() {
			await http.get(`resinas`).subscribe({
					next: (response:AxiosResponse) => {
							this.consultorioStore.resinas = response.data;
					},
			})
		}
		public async nuevaResina(data: any): Promise<any> {
			return new Promise((resolve, reject) => {
					this.consultorioStore.loading = true;
					http.post("resinas", data).subscribe({
							next: (response: AxiosResponse) => {
									this.consultorioStore.loading = false;
									if (response.data.res) {
											Alert.successTotastr(response.data.message,"Exito");
											this.globalStore.user = response.data.usuario;
											resolve(response.data);
									} else {
											Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
											resolve(false);
									}
							},
							error: (error) => {
									this.consultorioStore.loading = false;
									reject(error);
							}
					})
			});
		}
		public async nuevoComponente(data: any): Promise<any> {
			return new Promise((resolve, reject) => {
					this.consultorioStore.loading = true;
					http.post("componentes-resina", data).subscribe({
							next: (response: AxiosResponse) => {
									this.consultorioStore.loading = false;
									if (response.data.res) {
											Alert.successTotastr(response.data.message,"Exito");
											this.globalStore.user = response.data.usuario;
											resolve(response.data);
									} else {
											Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
											resolve(false);
									}
							},
							error: (error) => {
									this.consultorioStore.loading = false;
									reject(error);
							}
					})
			});
		}
		public async updateComponenteResina(data: any): Promise<any> {
			return new Promise((resolve, reject) => {
					this.consultorioStore.loading = true;
					http.put(`componentes-resina/${data.id}`, data).subscribe({
							next: (response: AxiosResponse) => {
									this.consultorioStore.loading = false;
									if (response.data.res) {
											Alert.successTotastr(response.data.message,"Exito");
											resolve(response.data);
									} else {
											Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
											resolve(false);
									}
							},
							error: (error) => {
									this.consultorioStore.loading = false;
									reject(error);
							}
					})
			});
		}
		public async registrarFichaArtificial(data: any): Promise<any> {
      return new Promise((resolve, reject) => {
          this.consultorioStore.loading = true;
          http.post("ficha-artificial", data).subscribe({
              next: (response: AxiosResponse) => {
                  this.consultorioStore.loading = false;
                  if (response.data.res) {
                      Alert.successTotastr(response.data.message,"Exito");
                      resolve(response.data);
                  } else {
                      Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                      resolve(false);
                  }
              },
              error: (error) => {
                  this.consultorioStore.loading = false;
                  reject(error);
              }
          })
      });
    }
		public async getFichasArtificiales(param: any) {
			await http.get(`ficha-artificial`, { params: param }).subscribe({
					next: (response:AxiosResponse) => {
							this.consultorioStore.fichas_artificiales = response.data;
					},
			})
		}
		public async eliminarFichaArtificial(id: number): Promise<any> {
		return new Promise((resolve, reject) => {
				this.consultorioStore.loading = true;
				http.delete(`ficha-artificial/${id}`).subscribe({
						next: (response: AxiosResponse) => {
								this.consultorioStore.loading = false;
								if (response.data.res) {
										Alert.successTotastr(response.data.message,"Exito");
										resolve(response.data);
								} else {
										Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
										resolve(false);
								}
						},
						error: (error) => {
								this.consultorioStore.loading = false;
								reject(error);
						}
				})
		});
	}
	public async updateResina(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.consultorioStore.loading = true;
            http.put(`resinas/${data.id}`, data).subscribe({
                next: (response: AxiosResponse) => {
                    this.consultorioStore.loading = false;
                    if (response.data.res) {
                        Alert.successTotastr(response.data.message,"Exito");
                        resolve(response.data);
                    } else {
                        Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                        resolve(false);
                    }
                },
                error: (error) => {
                    this.consultorioStore.loading = false;
                    reject(error);
                }
            })
        });
    }
	makePagination(page: any) {
		this.consultorioStore.pagination.per_page = page.per_page;
		this.consultorioStore.pagination.current_page = page.current_page;
		this.consultorioStore.pagination.last_page = page.last_page;
}
}